import LegalPage, { Section } from "@/components/LegalPage";

export default function ResponsibleGambling() {
  return (
    <LegalPage
      title="Responsible Gambling"
      metaTitle="AleaEdge Responsible Gambling Disclaimer"
      metaDescription="AleaEdge is informational only. Bet responsibly: set limits, recognize warning signs, and use 1-800-GAMBLER and other resources if you need help."
      canonical="/responsible-gambling"
      intro="Sports betting should be entertainment, not a way to make money or solve financial problems. AleaEdge provides analysis and information only — your decisions, and any wagers you place with a licensed sportsbook, are your own."
    >
      <Section title="No guaranteed outcomes">
        <p>No one can guarantee the result of a sporting event. AleaEdge picks and AI commentary are based on data, models, and informed opinion — they can and will be wrong. Treat every play as risk capital you can afford to lose.</p>
      </Section>

      <Section title="Bankroll guidance">
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Only wager money you can comfortably lose without affecting your day-to-day life.</li>
          <li>Set a fixed weekly or monthly bankroll and stick to it.</li>
          <li>Use flat or fractional unit sizing — avoid chasing losses with bigger bets.</li>
          <li>Take regular breaks. Losing streaks are normal.</li>
          <li>Never borrow money or use credit to gamble.</li>
        </ul>
      </Section>

      <Section title="Warning signs">
        <p>Consider stepping back, or seeking help, if you notice any of the following:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Betting more than you intended, or more often than you intended.</li>
          <li>Chasing losses or trying to "get even" with bigger wagers.</li>
          <li>Hiding the extent of your gambling from family or friends.</li>
          <li>Borrowing money, missing bills, or selling possessions to fund wagers.</li>
          <li>Feeling anxious, irritable, or depressed when not gambling.</li>
          <li>Gambling interfering with work, school, sleep, or relationships.</li>
        </ul>
      </Section>

      <Section title="Get help">
        <p>If gambling is no longer fun, free and confidential help is available 24/7.</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li><span className="text-foreground font-medium">National Council on Problem Gambling</span> — call or text <a href="tel:18004262537" className="text-primary hover:underline">1-800-GAMBLER</a>, or visit <a href="https://www.ncpgambling.org" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">ncpgambling.org</a>.</li>
          <li><span className="text-foreground font-medium">Gamblers Anonymous</span> — <a href="https://www.gamblersanonymous.org" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">gamblersanonymous.org</a>.</li>
          <li><span className="text-foreground font-medium">GamTalk</span> peer support — <a href="https://www.gamtalk.org" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">gamtalk.org</a>.</li>
          <li>Most regulated sportsbooks offer self-exclusion, deposit limits, and cool-off periods — use them.</li>
        </ul>
      </Section>

      <Section title="Age restrictions">
        <p>You must be at least 18 years old, and 21 in jurisdictions where 21 is the legal gambling age, to use AleaEdge or to wager with a regulated sportsbook. Underage gambling is illegal.</p>
      </Section>

      <Section title="Our commitment">
        <p>AleaEdge will never pressure you to bet, suggest specific stake sizes you cannot afford, or guarantee winnings. If you ask us to close your account, we will do so promptly.</p>
      </Section>
    </LegalPage>
  );
}
